import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { TableSortService } from '../../../services/table-sort.service';
import * as _ from "lodash";
import { IOnRowCell, ISTAction, ISTColumn } from './../../../interfaces/schema.interface';

@Component({
  selector: 'cargoes-schema-table',
  templateUrl: './schema-table.component.html',
  styleUrls: ['./schema-table.component.less']
})
export class SchemaTableComponent implements OnInit, OnChanges {
  @Input() columns: ISTColumn[] = [];
  @Input() data: any[] = [];
  @Input() actions: ISTAction[] = [];
  @Input() pageSize: number = 8;
  @Input() rowSize: any = 'small';
  @Output() onRowCell = new EventEmitter<any>();
  loadTable: boolean = false;
  showQuickJumper: boolean = false;
  sortName: string | null = null;
  sortValue: string | null = null;

  constructor(private tableSortService: TableSortService) { }

  ngOnInit() {
    this.init();
  }

  init(){
    if(!_.isEmpty(this.columns) && !_.isEmpty(this.data)){
      this.loadTable = true;
      if( (this.data.length/this.pageSize) > 9 ){
        this.showQuickJumper = true;
      }
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes['data'].previousValue === undefined &&
       changes['data'].currentValue !== undefined){
      this.data = changes['data'].currentValue;
      this.init();
    }

  }

  onSort(sort: any): void {
    this.data = this.tableSortService.getSortedData(sort,this.data);
    this.data = [...this.data];
  }

  /**
   * Return a clicked cell dat of table
   * @param column        : A clicked column
   * @param clickDataRow  : A clicked cell data
   */
  onRowCellClick(column: ISTColumn, clickDataRow: any){
    let data: IOnRowCell = {'column':column, 'data': clickDataRow};
    this.onRowCell.emit(data);
  }
}
